import { windowGlobal } from '@/base/utils/isWindowAvailable';

export function readQueryParams() {
  if (!windowGlobal) return null;
  const urlSearchParams = new URLSearchParams(windowGlobal?.location.search);
  return Object.fromEntries(urlSearchParams.entries());
}
